interface NameParts {
  lastName?: string | null;
  firstName?: string | null;
  patronymic?: string | null;
}

const initial = (value?: string | null): string => {
  const trimmed = (value ?? '').trim();
  return trimmed ? `${trimmed.charAt(0).toUpperCase()}.` : '';
};

/**
 * Фамилия с инициалами: «Иванов И.П.»; если отчества нет — «Иванов И.».
 */
export function formatShortName(person?: NameParts | null): string {
  if (!person) return '';

  const lastName = (person.lastName ?? '').trim();
  const initials = `${initial(person.firstName)}${initial(person.patronymic)}`;

  return [lastName, initials].filter(Boolean).join(' ');
}
